import {Temporal} from 'temporal-polyfill';

export const isEventTimeInvalid = (
  timeToCheck: Temporal.PlainTime,
  eventDate: string | null,
  temporalNow: Temporal.ZonedDateTime,
  isAdmin: boolean,
): boolean => {
  if (isAdmin || !timeToCheck || !eventDate) return false;

  const isToday = eventDate === temporalNow.toPlainDate().toString();
  if (!isToday) return false;

  return Temporal.PlainTime.compare(temporalNow.toPlainTime(), timeToCheck) > 0;
};
